/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Edit_HeadingInputs */

const en_templates_edit_heading = /** @type {(inputs: Templates_Edit_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit template`)
};

const he_templates_edit_heading = /** @type {(inputs: Templates_Edit_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עריכת תבנית`)
};

/**
* | output |
* | --- |
* | "Edit template" |
*
* @param {Templates_Edit_HeadingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_edit_heading = /** @type {((inputs?: Templates_Edit_HeadingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Edit_HeadingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_edit_heading(inputs)
	return he_templates_edit_heading(inputs)
});